﻿export class EqualityHelper {

    public static isNil(htmlElement: HTMLElement) {
        return ((typeof htmlElement) !== "undefined" && htmlElement !== null);
    }
}